
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import ServiceGrid from './components/ServiceGrid';
import AboutUs from './components/AboutUs';
import ProjectGallery from './components/ProjectGallery';
import Reliability from './components/Reliability';
import ServiceAreaMap from './components/ServiceAreaMap';
import StickyFooterCTA from './components/StickyFooterCTA';
import EstimateModal from './components/EstimateModal';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schemaData = [
  {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': `${SITE_URL}/#localbusiness`,
    name: 'Mobile Welding Repair & Fabrication',
    description:
      'Professional mobile welding and fabrication services in Madison Lake and Eagan, Minnesota. AWS certified welders for emergency repairs, custom fabrication, and commercial industrial welding.',
    url: SITE_URL,
    telephone: '+15073980496',
    priceRange: '$$',
    image: 'https://static.readdy.ai/image/042557a158b596551b7acb61d66aac00/ae9ed59fe1896a8f4d9b0d1f20cc888c.png',
    address: [
      {
        '@type': 'PostalAddress',
        streetAddress: '',
        addressLocality: 'Madison Lake',
        addressRegion: 'MN',
        postalCode: '56063',
        addressCountry: 'US',
      },
      {
        '@type': 'PostalAddress',
        streetAddress: '',
        addressLocality: 'Eagan',
        addressRegion: 'MN',
        postalCode: '55122',
        addressCountry: 'US',
      },
    ],
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 44.2044,
      longitude: -93.8152,
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        opens: '07:00',
        closes: '18:00',
      },
    ],
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Welding & Fabrication Services',
      itemListElement: [
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Emergency Welding Repair' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Custom Metal Fabrication' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Structural Welding' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Heavy Equipment Repair' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Commercial Industrial Welding' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Mobile On-Site Welding' } },
      ],
    },
    areaServed: [
      { '@type': 'City', name: 'Madison Lake', containedInPlace: { '@type': 'State', name: 'Minnesota' } },
      { '@type': 'City', name: 'Eagan', containedInPlace: { '@type': 'State', name: 'Minnesota' } },
      { '@type': 'State', name: 'Minnesota' },
    ],
    sameAs: [],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${SITE_URL}/#website`,
    url: SITE_URL,
    name: 'Mobile Welding Repair & Fabrication',
    description: 'Mobile welding and fabrication services in Madison Lake & Eagan, MN.',
    inLanguage: 'en-US',
  },
];

export default function HomePage() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const existingScripts = document.querySelectorAll('script[data-schema="home"]');
    existingScripts.forEach((s) => s.remove());

    schemaData.forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', 'home');
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    return () => {
      document.querySelectorAll('script[data-schema="home"]').forEach((s) => s.remove());
    };
  }, []);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <div className="min-h-screen bg-white">
      <Hero onOpenModal={handleOpenModal} />
      <ServiceGrid />
      <AboutUs />
      <ProjectGallery />
      <Reliability />
      <ServiceAreaMap />
      <StickyFooterCTA onOpenModal={handleOpenModal} />
      <EstimateModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </div>
  );
}
